import { Decimal, bn } from '../core/BigNumber';

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Price for buying `count` buildings starting at current `owned` amount. */
export function buildingBulkPrice(
  basePrice: Decimal,
  priceMultiplier: number,
  owned: number,
  count: number,
): Decimal {
  let total = bn(0);
  for (let i = 0; i < count; i++) {
    total = total.add(basePrice.mul(bn(priceMultiplier).pow(owned + i)));
  }
  return total.ceil();
}

/** Single building price at a given `owned` count. */
export function buildingPrice(
  basePrice: Decimal,
  priceMultiplier: number,
  owned: number,
): Decimal {
  return basePrice.mul(bn(priceMultiplier).pow(owned)).ceil();
}

/** How much prestige from a given amount of cookies forfeited. */
export function calcPrestige(cookiesForfeited: Decimal): Decimal {
  if (cookiesForfeited.lt(1e12)) return bn(0);
  return cookiesForfeited.div(1e12).pow(0.5).floor();
}
